{{#if backdrop}}
    <div class="backdrop"></div>
{{/if}}
<div class="blocks"></div>
<div class="feedback"></div>
